import React from 'react';
import { Box, Modal } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'var(--c-background2)',
  borderRadius: '10px',
  p: 4,
  border: '1px solid var(--c-primary-color)',
  height: '20rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
};
interface ErrorDialogProps {
  message: string[] | string;
}
export const PopupErrorDialog: React.FC<ErrorDialogProps> = ({ message }) => {
  return (
    <Modal open={true} aria-describedby="modal-modal-description">
      <Box
        role="dialog"
        aria-labelledby="modal-modal-title"
        sx={style}
        aria-label={Array.isArray(message) ? message.join(', ') : message}
      >
        {Array.isArray(message) ? (
          message.map((msg, index) => (
            <p key={index} id={`modal-modal-description-${index}`} className="text-[--c-error]">
              {msg}
            </p>
          ))
        ) : (
          <p id="modal-modal-description" className="text-[--c-error]">
            {message}
          </p>
        )}
      </Box>
    </Modal>
  );
};
